module.exports = __webpack_public_path__ + "static/media/sleeping.857c077a.png";